export default "__VITE_ASSET__CtVWAo2z__"